import React from 'react';
import { Star } from 'lucide-react';
const Testimonials = () => {
  const testimonials = [{
    id: 1,
    name: 'Ahmad Ibrahim',
    avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
    rating: 5,
    text: 'Our Umrah journey with Kembara Ustaz was truly life-changing. The guides were knowledgeable and the accommodations were excellent. Will definitely book with them again!',
    trip: 'Classic Umrah Journey'
  }, {
    id: 2,
    name: 'Siti Aminah',
    avatar: 'https://randomuser.me/api/portraits/women/44.jpg',
    rating: 5,
    text: 'The attention to detail and spiritual guidance provided by Kembara Ustaz made our Umrah experience meaningful and hassle-free. Highly recommended!',
    trip: 'Extended Umrah Experience'
  }, {
    id: 3,
    name: 'Mohammed Ali',
    avatar: 'https://randomuser.me/api/portraits/men/62.jpg',
    rating: 4,
    text: 'Great service from start to finish. The team was responsive to our needs and the itinerary was perfectly balanced. Looking forward to our next trip with them.',
    trip: 'Thailand Delight'
  }];
  return <div className="py-16 bg-white" data-id="element-526">
      <div className="container mx-auto px-4 md:px-8" data-id="element-527">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-navy-900 mb-2" data-id="element-528">
          Customer Testimonials
        </h2>
        <p className="text-center text-navy-700 mb-10" data-id="element-529">
          Hear from our satisfied travelers
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-530">
          {testimonials.map(testimonial => <div key={testimonial.id} className="bg-white p-6 rounded-lg shadow-md border border-gray-100" data-id="element-531">
              <div className="flex items-center mb-4" data-id="element-532">
                <img src={testimonial.avatar} alt={testimonial.name} className="w-12 h-12 rounded-full mr-4" data-id="element-533" />
                <div data-id="element-534">
                  <h3 className="font-medium text-navy-900" data-id="element-535">
                    {testimonial.name}
                  </h3>
                  <div className="flex" data-id="element-536">
                    {[...Array(5)].map((_, i) => <Star key={i} size={16} className={i < testimonial.rating ? 'text-gold-500 fill-gold-500' : 'text-gray-300'} data-id="element-537" />)}
                  </div>
                </div>
              </div>
              <p className="text-navy-700 mb-4" data-id="element-538">"{testimonial.text}"</p>
              <div className="text-sm text-navy-600" data-id="element-539">
                Trip: {testimonial.trip}
              </div>
            </div>)}
        </div>
      </div>
    </div>;
};
export default Testimonials;